export default "/kiban/_next/static/images/circuit-5d8ab6ef41a6d171a381227463673812.png";